module.exports = __webpack_public_path__ + "assets/img/main-feature-3.7a4eeecb.png";